var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "support-container row m-0" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 mb-15" },
          [
            _c(
              "router-link",
              { staticClass: "sub-link", attrs: { to: "/layout/dashboard" } },
              [
                _c("img", {
                  attrs: {
                    src: "/static/images/icons/chevron_left.svg",
                    alt: "chevron-icon",
                  },
                }),
                _vm._v("Help and Support "),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 sub-heading mb-20" }, [
          _vm._v(
            " Feel free to drop us a message or search our comprehensive knowledge base. "
          ),
        ]),
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "row mb-30" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c("div", { staticClass: "form-group" }, [_vm._v("Subject")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.support.subject,
                    expression: "support.subject",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Enter Subject",
                  maxlength: "100",
                },
                domProps: { value: _vm.support.subject },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.support, "subject", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "row mb-30" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 custom-dropdown" },
              [
                _c("div", { staticClass: "form-group" }, [
                  _vm._v("Service/Area"),
                ]),
                _c("multiselect", {
                  staticClass: "multiselect-single-dropdown",
                  class: !_vm.support.service ? "un-selected" : "",
                  attrs: {
                    showLabels: false,
                    "close-on-select": true,
                    "allow-empty": false,
                    searchable: false,
                    options: _vm.services,
                    placeholder: "Select Service/Area",
                  },
                  model: {
                    value: _vm.support.service,
                    callback: function ($$v) {
                      _vm.$set(_vm.support, "service", $$v)
                    },
                    expression: "support.service",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "row mb-30" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
              _c("div", { staticClass: "form-group" }, [_vm._v("Message")]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.support.message,
                    expression: "support.message",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control text-box",
                attrs: {
                  type: "text",
                  placeholder: "How can we help?",
                  height: "440px",
                },
                domProps: { value: _vm.support.message },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.support, "message", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "row mb-10" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-6 col-lg-5" }, [
              _c("input", {
                ref: "file",
                attrs: { type: "file", name: "", id: "custom-file" },
                on: { change: _vm.fileChange },
              }),
              _c(
                "label",
                { attrs: { for: "custom-file" } },
                [
                  _c(
                    "base-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        selector: ".support-container",
                        content:
                          "PDF, Excel, PPT, DOC, Image file types accepted",
                      },
                    },
                    [
                      _c("div", { staticClass: "cursor-pointer" }, [
                        _c("img", {
                          staticClass: "attachment-icon",
                          attrs: {
                            src: "/static/images/icons/attachment_icon_blue.svg",
                            alt: "attachment-icon",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass:
                              "attachment-label text-emergo-dark-blue",
                          },
                          [_vm._v("Add an Attachment")]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm.file
                ? _c("div", { staticClass: "file-success" }, [
                    _c("span", [_vm._v(_vm._s(_vm.file.name))]),
                    _c("img", {
                      staticClass: "cursor-pointer",
                      attrs: {
                        src: "/static/images/icons/close_icon.svg",
                        width: "14px",
                        alt: "close-icon",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.resetFile()
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "mb-10" }, [
            _vm.showError
              ? _c("div", { staticClass: "file-error" }, [
                  _vm._v(_vm._s(_vm.showError)),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "row mb-30" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-3 col-md-offset-6 col-sm-offset-4 col-sm-4 col-xs-6 col-lg-offset-8 col-lg-2",
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    attrs: { to: "/layout/dashboard" },
                  },
                  [_vm._v(" Cancel ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "col-md-3 col-sm-4 col-xs-6 col-lg-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-block emergo-green-button",
                  attrs: { type: "button" },
                  on: { click: _vm.sendSupportMessage },
                },
                [_vm._v(" Send ")]
              ),
            ]),
          ]),
          _c("div", { staticClass: "row border-top center pt-25" }, [
            _c("span", { staticClass: "attachment-label" }, [
              _vm._v(" If you would like to, please contact "),
              _vm.support.service != "Smart Builder" &&
              _vm.support.service != "Smart Exchange"
                ? _c("a", { attrs: { href: "mailto:ramshelp@ul.com" } }, [
                    _vm._v("RAMShelp@ul.com."),
                  ])
                : _c(
                    "a",
                    {
                      attrs: { href: "mailto:LST.Global.RAMShelp-SBSX@ul.com" },
                    },
                    [_vm._v("LST.Global.RAMShelp-SBSX@ul.com.")]
                  ),
            ]),
          ]),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }